import { IconButton } from '@material-ui/core';
import STooltip from '@setvi/shared/components/stooltip';

export const PromotionBadge = ({ onClick }: { onClick?: () => void }) => (
  <STooltip title="Promotions">
    <IconButton
      size="small"
      style={{ padding: 0 }}
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}>
      <img style={{ width: 20 }} src="/images/product-promotion.png" />
    </IconButton>
  </STooltip>
);
